import { loadAllDataSets } from 'js/actions';
import { generateOptionsFromDataSets } from 'new/utils/DataSetUtil/generateOptionsFromDataSets';
import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useDataSetsOptionsWithPreloading = () => {
  const dispatch = useDispatch();
  const dataSetsLoaded = useRef(false);
  const state = useSelector((s: any) => s);

  const {
    entities: { dataSets },
    dataSets: { byId },
  } = state;

  const load = () => dispatch(loadAllDataSets());

  useEffect(() => {
    if (!dataSetsLoaded.current || !Object.values(dataSets).length) {
      dispatch(loadAllDataSets());
      dataSetsLoaded.current = true;
    }
  }, [dispatch]);

  return useMemo(
    () => ({
      options: generateOptionsFromDataSets(byId, dataSets),
      fetch: load,
    }),
    [byId, dataSets],
  );
};
